/*-----------------------------------------------------------------
- Footer
-----------------------------------------------------------------*/
export default {
    login      : 'ورود',
    register   : 'ثبت‌نام',
    search     : 'جستجو کنید',
    separator  : ' / ',
    auth_button: 'ورود / ثبت‌نام',
    auth_avatar: 'آواتار کاربر',
};
